import { safeStorageGet, safeStorageSet } from 'src/utils/safeStorage'

/**
 * "Already answered on this browser" flag for the ¿Cómo nos conociste?
 * prompt. The durable record is server-side (User stamp / HubSpot contact);
 * this only stops an ANONYMOUS visitor — who has no User to look up — from
 * being asked again on their next lead. Storage unavailable reads as "not
 * answered": worst case they are asked again, and the server's set-once
 * keeps the first answer.
 */

const KEY = 'spotme_self_reported_source_v1'

export function hasAnsweredLocally(): boolean {
  return safeStorageGet('local', KEY) !== null
}

export function markAnsweredLocally(source: string): void {
  safeStorageSet(
    'local',
    KEY,
    JSON.stringify({ source, answeredAt: Date.now() })
  )
}
